import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Input } from '@Components/ui-v2/input';

interface NavSidebarSearchProps {
  value: string;
  onChange: (next: string) => void;
}

const NavSidebarSearch = ({ value, onChange }: NavSidebarSearchProps) => {
  const { t } = useTranslation();
  return (
    <div className="px-3 py-3">
      <div className="relative">
        <Search
          size={13}
          strokeWidth={1.75}
          className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-gray-400"
          aria-hidden
        />
        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('Agent.SearchPlaceholder')}
          className="h-8 py-1.5 pl-7 pr-7 text-sm text-gray-800 placeholder:text-gray-400 bg-[#fbfaf9] border-gray-100 transition-[border-color,box-shadow] duration-200 ease-out focus-visible:ring-1 focus-visible:ring-[#7c6cf6]/30 focus-visible:ring-offset-0 focus-visible:border-[#7c6cf6]/40"
          style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}
        />
        {value && (
          <button
            type="button"
            aria-label={t('Agent.AriaClearSearch')}
            onClick={() => onChange('')}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer hover:text-gray-700">
            <X size={12} strokeWidth={1.75} />
          </button>
        )}
      </div>
    </div>
  );
};

export default NavSidebarSearch;
